import { render, staticRenderFns } from "./BodyEditor.vue?vue&type=template&id=7490548f&scoped=true"
import script from "./BodyEditor.vue?vue&type=script&lang=js"
export * from "./BodyEditor.vue?vue&type=script&lang=js"
import style0 from "./BodyEditor.vue?vue&type=style&index=0&id=7490548f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7490548f",
  null
  
)

export default component.exports